import { render, staticRenderFns } from "./DownloadsPage.vue?vue&type=template&id=fa3d152a&scoped=true"
import script from "./DownloadsPage.vue?vue&type=script&lang=js"
export * from "./DownloadsPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadsPage.vue?vue&type=style&index=0&id=fa3d152a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3d152a",
  null
  
)

export default component.exports